<section>

  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>

  <datalist id="listfuncionarios">
    <select>
      <option *ngFor="let item of osCompleta?.possiveisColaboradores" [value]="item.nome"></option>
    </select>
  </datalist>

  <datalist id="listmateriais">
    <select>
      <option *ngFor="let item of osCompleta?.possiveisMateriais" [value]="item.descricao"></option>
    </select>
  </datalist>


</section>


<div class="box-table" [style.height.px]="this.heightGridPx">

  <table>
    <thead>
      <tr>
        <th class="w90">
          <section style="display: flex; justify-content: space-around;">
            <span>#</span>
            <i class="fa fa-check-circle txt-green cp" (click)="markDesmarkAllToPriting()"
              title="Marcar/Desmarcar todas OSs para reimpressão">
            </i>
          </section>
        </th>
        <th class="w40">#</th>
        <th (click)="sortTable('osId')" class="cp">Nº OS
          <span class="fa text-primary pl-3" [ngClass]="{
            'fa-sort-alpha-asc' : this.sortColumn == 'osId' && this.sortType == 'asc', 
            'fa-sort-alpha-desc': this.sortColumn == 'osId' && this.sortType == 'desc'
          }"></span>
        </th>
        <th (click)="sortTable('equipamentoDescricao')" class="cp">Equipamento
          <span class="fa text-primary pl-3" [ngClass]="{
            'fa-sort-alpha-asc' : this.sortColumn == 'osId' && this.sortType == 'asc', 
            'fa-sort-alpha-desc': this.sortColumn == 'osId' && this.sortType == 'desc'
          }"></span>
        </th>
        <th (click)="sortTable('statusStr')" class="cp">Status
          <span class="fa text-primary pl-3" [ngClass]="{
            'fa-sort-alpha-asc' : this.sortColumn == 'statusStr' && this.sortType == 'asc', 
            'fa-sort-alpha-desc': this.sortColumn == 'statusStr' && this.sortType == 'desc'
          }"></span>
        </th>
        <th (click)="sortTable('servicoSolicitado')" class="cp">Serviço Solicitado
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'servicoSolicitado' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'servicoSolicitado' && this.sortType == 'desc'
        }"></span>
        </th>
        <th (click)="sortTable('servicoRealizado')" class="cp">Serviço Executado
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'servicoRealizado' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'servicoRealizado' && this.sortType == 'desc'
        }"></span>
        </th>
        <th (click)="sortTable('dataHoraEmissao')" class="cp">Data OS
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'dataHoraEmissao' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'dataHoraEmissao' && this.sortType == 'desc'
        }"></span>
        </th>
        <th (click)="sortTable('dataHoraFimExecStr')" class="cp">Data Execução
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'dataHoraFimExec' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'dataHoraFimExec' && this.sortType == 'desc'
        }"></span>
        </th>

        <th (click)="sortTable('local')" class="cp">Local
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'local' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'local' && this.sortType == 'desc'
        }"></span>
        </th>
        <th (click)="sortTable('areaTecnica')" class="cp">Área Técnica
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'areaTecnica' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'areaTecnica' && this.sortType == 'desc'
        }"></span>

        </th>
        <th (click)="sortTable('prioridadeStr')" class="cp">Prioridade
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'prioridadeStr' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'prioridadeStr' && this.sortType == 'desc'
        }"></span>
        </th>
        <th (click)="sortTable('tipoOSStr')" class="cp">Tipo de OS
          <span class="fa text-primary pl-3" [ngClass]="{
          'fa-sort-alpha-asc' : this.sortColumn == 'tipoOSStr' && this.sortType == 'asc', 
          'fa-sort-alpha-desc': this.sortColumn == 'tipoOSStr' && this.sortType == 'desc'
        }"></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of this.listaDeOSs">
        <td class="text-center cp" title="Marcar esta OS para reimpressão">
          <button type="button" class="btn btn-sm" (click)="markForPrinting(item?.id, item?.tipoOSFilha)"
            [disabled]="!podeImprimir">
            <i class="fa fa-print text-primary"></i>
            <i class="fa fa-check-circle txt-green pl-1 pb-2" *ngIf="item.marked"></i>
          </button>
        </td>
        <td class="text-center cp" title="Visualizar Detalhes OS Nº {{ item?.id | zerosEsquerda : 5 }}">
          <button type="button" class="btn btn-sm" (click)="getById(item?.id, item?.spvId, modalDetalhesSpv)">
            <i class="fa fa-eye text-primary"></i>
          </button>
        </td>
        <td class="text-center cp w90">{{ item?.id | zerosEsquerda : 5 }}</td>
        <td class="text-center">{{item?.equipamentoDescricao}}</td>
        <td class="text-center">
          <section style="display:flex; flex-direction: row; justify-content: space-between">
            <span class="badge badge-pill fw mr-2" [ngStyle]="{'background-color' : bgStatus[item?.status]}">{{
              item?.statusStr }}
            </span>
            <span *ngIf="item.irregularidadeId != null" [title]="item.irregularidadeDescricao">
              <i class="fa fa-tags fa-lg text-danger" aria-hidden="true"></i>
            </span>
          </section>
        </td>
        <td>{{ item?.servicoSolicitado }}</td>
        <td>{{ item?.servicoRealizado }}</td>
        <td>{{ item?.dataHoraEmissao | date : 'dd/MM/yyyy' }}</td>
        <td>{{ item?.dataHoraFimExec | date : 'dd/MM/yyyy' }}</td>
        <td class="text-center">{{ item?.local }}</td>
        <td class="text-center">{{ item?.areaTecnica }}</td>
        <td class="text-center">{{ item.prioridadeStr }}</td>
        <td class="text-center">{{ item?.tipoOSStr }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="row mt-3">

  <div class="col-md-3">
    <div class="d-flex justify-content-start">
      <div class="custom-checkbox custom-control">
        <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px;" [checked]="false"
          #imprimirEvidenciaDeFotos>
        <label class="form-check-label" for=""><span class="fs11">Imprime a evidência de fotos?</span></label>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <button type="button" class="btn btn-light cp" style="display: flex;" [disabled]="this.countMarked <= 0"
      (click)="printingOSs()">
      <section class="pr-3">
        <i class="fa fa-print text-primary"></i>
      </section>
      <span class="pr-3">
        Reimprimir OSs selecionadas
      </span>
      <span *ngIf="this.countMarked > 0" class="badge badge-pill badge-success">{{ this.countMarked }}
      </span>
      <span *ngIf="this.isPrintingOSs" class="fa fa-spinner fa-spin fa-fw"></span>


    </button>
  </div>

  <div class="col-md-3 text-center">

    <i class="fa fa-tags fa-lg text-danger" aria-hidden="true"></i>
    <span>
      indica a existência de pendência
    </span>

  </div>

  <div class="col-md-2">
    <div class="d-flex justify-content-end">

      <span *ngIf="this.listaDeOSs?.length == 0" class="pl-2 pt-1 pb-2"><b>Nenhum OS
          encontrada</b></span>
      <span *ngIf="this.listaDeOSs?.length > 0" class="pl-2 pt-1 pb-2">Total:
        <b>{{ this.listaDeOSs?.length }}</b></span>
      <app-ball-pulse *ngIf="imprimindoOS" class="pull-right"></app-ball-pulse>

    </div>

  </div>
</div>


<!-- ********************* MODAIS ************************** -->

<ng-template #modalDetalhesSpv let-c="close" let-d="dismiss">
  <div class="modal-header">
    <section style="
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 100%;
      ">
      <h4 class="modal-title" style="flex: 5">
        Consulta detalhada de OS Nº
        <b><span>{{ osCompleta?.osId | zerosEsquerda: 5 }}</span></b>
      </h4>
      <span style="flex: 1" class="badge badge-pill fw mr-2"
        [ngStyle]="{ 'background-color': bgStatus[osCompleta?.status] }">
        {{ statusOS[osCompleta?.status] }}
      </span>
    </section>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class=" bx-tb-detalhes pre-scrollable h650">

          <form novalidate [formGroup]="form" (validSubmit)="submit(modalDetalhesSpv)">

            <table class="table table-bordered tb-detalhes">
              <thead style="border-collapse:collapse; border-spacing: 0">
                <td style="width: 20%"></td>
                <td style="width: 30%"></td>
                <td style="width: 20%"></td>
                <td style="width: 25%"></td>
                <td style="width: 5%"></td>
              </thead>
              <tbody>
                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                </tr>
                <tr>
                  <th colspan="5" class="text-center title">Cadastro</th>
                </tr>
                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>

                <tr>
                  <th>Data Hora do Cadastro</th>
                  <td>
                    <input type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.dataHoraCadastro | date:'dd/MM/yyyy HH:mm'" disabled />
                  </td>
                  <th>Usuário Solicitante</th>
                  <td colspan="2">
                    <input type="text" class="form-control" [value]="osCompleta?.spvCompleto.usuarioSolicitante"
                      disabled>
                  </td>
                </tr>

                <tr>
                  <th>Requisitante</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.requisitante" disabled />
                    <input *ngIf="this.modoEdicao" type="text" class="form-control" formControlName="requisitante"
                      maxlength="20" tabindex="-1" />
                  </td>
                  <th>Ramal</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control" maxlength="40"
                      [value]="osCompleta?.spvCompleto.contato" disabled>
                    <input *ngIf="this.modoEdicao" type="text" class="form-control" formControlName="contato"
                      maxlength="40" tabindex="-1" />
                  </td>
                </tr>

                <tr>
                  <th>Serviço</th>
                  <td colspan="4">
                    <textarea *ngIf="!this.modoEdicao" class="form-control" [value]="osCompleta?.spvCompleto.servico"
                      disabled style="resize: none;"></textarea>
                    <textarea *ngIf="this.modoEdicao" class="form-control" formControlName="servico"
                      style="resize: none;" tabindex="-1"></textarea>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <th>Status Atual</th>
                  <td>
                    <input type="text" class="form-control" [value]="osCompleta?.spvCompleto.statusStr" disabled />
                  </td>

                  <th>Data Status</th>
                  <td colspan="2"><input type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.dataStatus | date:'dd/MM/yyyy'" disabled /></td>
                </tr>
                <tr>
                  <th>{{labelCentroCusto}}</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.centroCusto" disabled />


                    <div *ngIf="this.modoEdicao" class="input-group">
                      <input type="text" class="form-control pr-0" list="listCentroCustos"
                        (change)="changeDataListCentroCustos($event.target.value)" maxlength="40"
                        formControlName="datalistCentroCustos" tabindex="-1" />
                      <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                        title="limpar campo e recarregar lista de opções">
                        <span class="input-group-text"><i class="fa fa-trash"></i></span>
                      </div>
                    </div>

                  </td>
                  <th>Localização</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.localizacao" disabled>
                    <input *ngIf="this.modoEdicao" type="text" class="form-control" formControlName="localizacao"
                      maxlength="40" tabindex="-1" />
                  </td>

                </tr>



                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px;"></td>
                </tr>

                <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                  <th colspan="5" class="text-center title">Aprovação/Qualificação</th>
                </tr>
                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>
                <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                  <th>Data Aprovação</th>
                  <td>
                    <input type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.dataHoraAprovacao | date:'dd/MM/yyyy'" disabled />
                  </td>
                  <th>Aprovado por</th>
                  <td colspan="2">
                    <input type="text" class="form-control" [value]="osCompleta?.spvCompleto.aprovadoPor" disabled />
                  </td>
                </tr>
                <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                  <th>Qualificado por</th>
                  <td>
                    <input type="text" class="form-control" [value]="osCompleta?.spvCompleto.qualificadoPor" disabled />
                  </td>
                  <th>Prioridade</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.prioridadeStr" disabled>

                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="prioridadeId" tabindex="-1">
                      <option value="" selected>selecione</option>
                      <option *ngFor="let pri of prioridades" [value]="pri.id">{{pri.descricao}}</option>
                    </select>

                  </td>
                </tr>
                <tr *ngIf="osCompleta?.spvCompleto.ptId != null">
                  <th>Data Aprovação</th>
                  <td>
                    <input type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.dataHoraAprovacao | date:'dd/MM/yyyy'" disabled />
                  </td>
                  <th>Prioridade</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.prioridadeStr" disabled>

                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="prioridadeId" tabindex="-1">
                      <option value="" selected>selecione</option>
                      <option *ngFor="let pri of prioridades" [value]="pri.id">{{pri.descricao}}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Observações Gerais</th>
                  <td colspan="4">
                    <textarea *ngIf="!this.modoEdicao" class="form-control"
                      [value]="osCompleta?.spvCompleto.observacoesGerais" disabled style="resize: none;"></textarea>
                    <textarea *ngIf="this.modoEdicao" class="form-control" formControlName="observacoesGerais"
                      style="resize: none;" tabindex="-1"></textarea>
                  </td>
                </tr>
                <tr>
                  <th>Área restrita</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.areaRestritaStr" disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="areaRestrita" tabindex="-1">
                      <option value=true>SIM</option>
                      <option value=false>NÃO</option>
                    </select>

                  </td>
                  <th>Fim de Semana</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.fimDeSemanaStr" disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="fimDeSemana" tabindex="-1">
                      <option value=''>N/A</option>
                      <option value=true>SIM</option>
                      <option value=false>NÃO</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Engenheiro Responsável</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.engenheiroResponsavel == '' ? ' - ' : osCompleta?.spvCompleto.engenheiroResponsavel"
                      disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="engenheiroResponsavelId"
                      tabindex="-1">
                      <option value="">selecione</option>
                      <option *ngFor="let e of this.engenheiros" value="{{ e.id }}">{{ e.nome }}</option>
                    </select>
                  </td>
                  <th>Responsável OS</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.encarregadoResponsavel == null ? ' - ' : osCompleta?.spvCompleto.encarregadoResponsavel"
                      disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="encarregadoResponsavelId"
                      tabindex="-1">
                      <option value="">selecione</option>
                      <option *ngFor="let e of this.encarregados" value="{{ e.id }}">{{ e.nome }}</option>
                    </select>
                  </td>
                </tr>


                <tr>
                  <th>Área Técnica</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.areaTecnica" disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="areaTecnicaId" tabindex="-1">
                      <option *ngFor="let t of areasTecnicas" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </td>
                  <th>Local</th>
                  <td colspan="2">

                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.localStr" disabled />
                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="localId"
                      (change)="getEquipamentoPorLocalId($event.target.value)" tabindex="-1">
                      <option *ngFor="let local of locaisPorNivel" [value]="local.id">{{ local.nome }}</option>
                    </select>


                  </td>
                </tr>

                <tr>
                  <th>Equipamento</th>
                  <td>
                    <input *ngIf="!this.modoEdicao" type="text" class="form-control"
                      [value]="osCompleta?.spvCompleto.equipamento" disabled />

                    <select *ngIf="this.modoEdicao" class="form-control" formControlName="equipamentoId" tabindex="-1">
                      <option value="" selected>selecione</option>
                      <option *ngFor="let eq of equipamentos" value="{{ eq.id }}">{{ eq.nome }}</option>
                    </select>



                  </td>
                  <th>Empreiteira</th>
                  <td colspan="3">
                    <input type="text" class="form-control" [value]="osCompleta?.spvCompleto.empreiteira" disabled />
                  </td>
                </tr>


                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                </tr>
                <tr *ngIf="this.modoEdicao">
                  <th colspan="4" class="text-center title ">Colaboradores</th>
                  <td class="text-center bg-primary cp" (click)="openModalColaboradores(modalcolaboradores)"
                    title="Adicionar novo Colaborador">
                    <span><i class="fwn fa fa-plus"></i></span>
                  </td>
                </tr>
                <tr *ngIf="!this.modoEdicao">
                  <th colspan="5" class="text-center title ">Colaboradores</th>
                </tr>
                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>

                <tr *ngFor="let c of osCompleta?.spvCompleto.colaboradores">
                  <td colspan="3" class="text-center" *ngIf="osCompleta.osFechamentoId == null">{{ c?.nome }}</td>
                  <td colspan="2" class="text-center" *ngIf="osCompleta.osFechamentoId == null">{{ c?.matricula }}</td>

                  <td class="text-center" *ngIf="osCompleta.osFechamentoId != null">{{ c?.nome }}</td>
                  <td class="text-center" *ngIf="osCompleta.osFechamentoId != null">{{ c?.matricula }}</td>
                  <td class="text-center" *ngIf="osCompleta.osFechamentoId != null">{{ c?.dataHoraInicio |
                    date:'dd/MM/yyyy HH:mm' }}</td>
                  <td colspan="2" class="text-center" *ngIf="osCompleta.osFechamentoId != null">{{ c?.dataHoraFim |
                    date:'dd/MM/yyyy HH:mm' }}</td>

                </tr>

                <tr *ngIf="this.validacoes.datasColaboradoresOK == false">
                  <td colspan="2"></td>
                  <td colspan="3" class="text-center">
                    <span class="txt-danger-fb text-center">Nem todas as datas Início e fim dos colaboradores foram
                      informadas</span>
                  </td>
                </tr>
                <tr *ngIf="osCompleta?.spvCompleto.colaboradores?.length == 0">
                  <th colspan="5" class="text-center">Não informado</th>
                </tr>

                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                </tr>
                <tr>
                  <th colspan="5" class="text-center title">Dados da realização</th>
                </tr>
                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>
                <tr>
                  <th>Data/Hora Inicio</th>
                  <td class="sem-borda">
                    <input *ngIf="!this.modoEdicao || this.osCompleta.status != 3" type="text" class="form-control fc"
                      [value]="osCompleta?.dataHoraInicioExec | date:'dd/MM/yyyy HH:mm'" id="dataHoraInicioExec"
                      tabindex="-1" disabled />

                    <input *ngIf="this.modoEdicao && this.osCompleta.status == 3" type="datetime-local"
                      class="form-control" tabindex="1" formControlName="dataHoraInicioExec" tabindex="-1"
                      [ngClass]="{'h-error' : this.validacoes.dataHoraInicioExec != ''}"
                      (change)="validaDadosRealizacao()" max="9999-12-31T23:59:59" />
                    <span *ngIf="this.validacoes.dataHoraInicioExec!=''" class="txt-danger">{{
                      this.validacoes.dataHoraInicioExec }}</span>

                  </td>
                  <th class="sem-borda">Data/Hora Fim</th>
                  <td colspan="2">
                    <input *ngIf="!this.modoEdicao || this.osCompleta.status != 3" type="text" class="form-control fc"
                      [value]="osCompleta?.dataHoraFimExec | date:'dd/MM/yyyy HH:mm'" id="dataHoraFimExec" tabindex="-1"
                      disabled />


                    <input *ngIf="this.modoEdicao && this.osCompleta.status == 3" type="datetime-local"
                      class="form-control" tabindex="-1" formControlName="dataHoraFimExec" tabindex="-1"
                      [ngClass]="{'h-error' : this.validacoes.dataHoraFimExec != ''}" (change)="validaDadosRealizacao()"
                      max="9999-12-31T23:59:59" />
                    <span *ngIf="this.validacoes.dataHoraFimExec!=''" class="txt-danger">{{
                      this.validacoes.dataHoraFimExec }}</span>

                  </td>
                </tr>
                <tr>
                  <th class="sem-borda">Cliente</th>
                  <td>
                    <input type="text" class="form-control fb" [value]="osCompleta?.cliente" readOnly />
                  </td>
                  <th>Matrícula</th>
                  <td colspan="2">
                    <input type="text" class="form-control fb" [value]="osCompleta?.matricula" readOnly />
                  </td>
                </tr>
                <tr>
                  <th>Setor</th>
                  <td>
                    <input type="text" class="form-control fb" [value]="osCompleta?.setor" readOnly />
                  </td>
                  <th class="sem-borda">Satisfeito</th>
                  <td *ngIf="osCompleta?.cliente || osCompleta?.matricula">
                    <input type="text" class="form-control fb" [value]="osCompleta?.satisfeito" readOnly
                      [value]="this.valores_satisfacao[osCompleta?.satisfeito]" />
                  </td>
                  <td class="sem-borda text-center" *ngIf="osCompleta?.cliente || osCompleta?.matricula">
                    <img src="./assets/images/{{imagens_satisfacao[osCompleta?.satisfeito]}}" style="width: 65%" />
                  </td>
                </tr>
                <tr>
                  <th>Serviço Realizado</th>
                  <td colspan="4">
                    <textarea *ngIf="!this.modoEdicao || this.osCompleta.status != 3" row="2" class="form-control fc"
                      [value]="osCompleta?.servicoRealizado" id="servicoRealizado" tabindex="-1" disabled>
                  </textarea>

                    <textarea *ngIf="this.modoEdicao && this.osCompleta.status == 3" row="2" class="form-control"
                      [value]="osCompleta?.servicoRealizado" tabindex="3" formControlName="servicoRealizado"
                      tabindex="-1" [ngClass]="{'h-error' : this.validacoes.servicoRealizado != ''}"
                      (change)="validaDadosRealizacao()">
                </textarea>
                    <span *ngIf="this.validacoes.servicoRealizado!=''" class="txt-danger">{{
                      this.validacoes.servicoRealizado }}</span>

                  </td>
                </tr>

                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                </tr>
                <tr *ngIf="!this.modoEdicao || this.osCompleta.status != 3">
                  <th colspan="5" class="text-center title">Irregularidades</th>
                </tr>


                <tr *ngIf="this.modoEdicao && this.osCompleta.status == 3">
                  <th colspan="4" class="text-center title">Irregularidades</th>
                  <td class="text-center bg-primary cp" (click)="openModalIrregularidades(modalirregularidades)"
                    title="Adicionar nova Irregularidade">
                    <span><i class="fwn fa fa-plus"></i></span>
                  </td>
                </tr>

                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>

                <tr>
                  <th class="text-center">Tipo Irregularidade</th>
                  <th colspan="4" class="text-center">Descrição</th>
                </tr>

                <tr *ngFor="let i of osCompleta.irregularidades">
                  <td>{{ i.tipoIrregularidade }}</td>
                  <td colspan="4">{{ i.descricao }}</td>

                </tr>
                <tr *ngIf="osCompleta?.irregularidades.length == 0">
                  <th colspan="5" class="text-center">Não informado</th>
                </tr>

                <tr>
                  <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                </tr>
                <tr *ngIf="!this.modoEdicao || this.osCompleta.status != 3">
                  <th colspan="5" class="text-center title">Materiais</th>
                </tr>

                <tr *ngIf="this.modoEdicao && this.osCompleta.status == 3">
                  <th colspan="4" class="text-center title">Materiais</th>
                  <td class="text-center bg-primary cp" (click)="openModalMateriais(modalMateriais)"
                    title="Adicionar novo material">
                    <span><i class="fwn fa fa-plus"></i></span>
                  </td>
                </tr>

                <tr>
                  <td colspan="5" style="border:hidden; padding: 7px;"></td>
                </tr>

                <tr>
                  <th class="text-center">Código</th>
                  <th colspan="2" class="text-center">Material</th>
                  <th class="text-center">Quantidade</th>
                  <th class="text-center">Unidade</th>
                </tr>

                <tr *ngFor="let item of osCompleta.materiaisUsado">
                  <td class="text-center">{{ item.codigo }}</td>
                  <td colspan="2">{{ item.descricao }}</td>
                  <td class="text-center">{{ item.quantidade }}</td>
                  <td class="text-center">{{ item.unidade }}</td>

                </tr>
                <tr *ngIf="osCompleta?.materiaisUsado.length == 0">
                  <th colspan="5" class="text-center">Não informado</th>
                </tr>


              </tbody>
            </table>


          </form>

          <!--  Registros fotográficos (ANTES)-->
          <section style="border-top: 2px solid #f39c12; margin-top: 15px;">
            <div class="form-row text-center" style="padding: 0 5px;">
              <div class="col-md-12 fb fs11" style="background-color: #eee; padding: 12px">
                <span class="txt-blue">
                  Registro fotográfico (Antes)
                </span>
              </div>
            </div>

            <div class="row showImagens" *ngIf="previewsPhotosAntes?.length > 0"
              style="padding-bottom: 20px; min-height: 100px;">
              <div class="col-md-2" *ngFor="let pview of previewsPhotosAntes">
                <div>
                  <img [src]="pview.dataUrl" class="zoom cp" (click)="openModalExibePhoto(modalExibePhoto, pview)">
                </div>
              </div>
            </div>

            <div *ngIf="previewsPhotosAntes?.length == 0" class="text-center"
              style="margin-top: 50px; margin-bottom: 50px;">
              <span>Nenhum registro fotográfico antes</span>
            </div>
          </section>


          <!--  Registros fotográficos (DEPOIS)-->

          <section style="border-top: 2px solid #f39c12; margin-top: 15px;" *ngIf="this.osCompleta.status == 3">

            <div class="form-row text-center" style="padding: 0 5px;">
              <div class="fb fs11" style="background-color: #eee; padding: 12px"
                [ngClass]="{'col-md-11': this.modoEdicao, 'col-md-12': !this.modoEdicao}">
                <span class="txt-blue">
                  Registro fotográfico (Depois)
                </span>
              </div>

              <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
                *ngIf="this.modoEdicao" (click)="fileInput.click()">
                <span><i class="fwn fa fa-plus"></i></span>
              </div>
            </div>

            <div class="row showImagens" style="padding-bottom: 20px; min-height: 100px;">
              <div class="col-md-2" *ngFor="let pview of previewsPhotos">
                <div>
                  <img [src]="pview.dataUrl" class="zoom cp" (click)="openModalExibePhoto(modalExibePhoto, pview)">
                  <button type="button" class="btn btn-default">
                    <i class="fa fa-trash text-secoundary" (click)="removerPhoto(pview.name)"
                      title="Remover esta foto"></i>
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="previewsPhotos?.length == 0" class="text-center" style="margin-top: 50px; margin-bottom: 50px;">
              <span>Nenhum registro fotográfico depois</span>
            </div>

          </section>


        </div>
      </div>
    </div>

    <app-log-avaliacao *ngIf="showModalLogAvaliacao" [shouldOpenModal]="showModalLogAvaliacao"
      [inputOSId]="osCompleta?.osId" (changeShowModal)="changeShowModal()"></app-log-avaliacao>

  </div>

  <div class="modal-footer" *ngIf="this.osCompleta?.status == 1">

    <div class=col-md-3></div>

    <div class="col-md-6">
      <div class="row form-group">
        <label class="col-md-4 col-form-label">Situação de pendência</label>
        <div class="col-md-8">
          <div [formGroup]="form">
            <select class="form-control" tabindex="-1" formControlName="irregularidadeId"
              [ngClass]="{'bg-danger': this.form.get('irregularidadeId').value != ''}" form="form">
              <option value="">Nenhuma pendência</option>
              <option *ngFor="let t of irregularidades" [value]="t.id">
                {{ t.descricao }}
              </option>
            </select>
          </div>
        </div>
      </div>

    </div>
    <div class=col-md-3></div>
  </div>

  <div class="modal-footer">

    <div class="col-md-3">
      <button *ngIf="this.modoEdicao" type="button" class="btn btn-secondary btn-block ml-3"
        (click)="openModalLog(modalLog)">Histórico de alterações
        <span *ngIf="this.osCompleta.logsAlteracoesOSs?.length > 0"
          class="badge badge-pill badge-warning pull-right pt-1">{{ this.osCompleta.logsAlteracoesOSs.length }}</span>
      </button>

    </div>

    <div class="col-md-3"></div>

    <div class="col-md-2">
      <button type="button" class="btn btn-info btn-block" (click)="setShowModalLogAvaliacao()">
        Logs de Avaliação
      </button>
    </div>


    <div class="col-md-2" *ngIf="this.osCompleta?.status == 6">
      <button type="button" class="btn btn-danger btn-block"
        (click)="showModalReabrirOS(osCompleta?.osId, modalReaberturaOS)">
        Reabrir OS
      </button>
    </div>

    <div class="col-md-2" *ngIf="this.osCompleta?.status != 6">
      <button *ngIf="this.modoEdicao" type="button" class="btn btn-warning btn-block" (click)="submit()">
        Editar
      </button>
    </div>

    <div class="col-md-2">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Retornar</button>
    </div>

  </div>
</ng-template>

<form novalidate [formGroup]="photoForm" class="row">
  <input hidden #fileInput formControlName="photo" type="file" accept="image/*" multiple
    (change)="handleFile($event.target.files)">
</form>


<ng-template #modalcolaboradores let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Informar Colaboradores</h4>
  </div>

  <div class="modal-body pl-5 pr-5 pb-0">

    <div class="row">
      <div class="col-md-12">

        <div class="row">
          <div class="offset-md-3 col-md-6">

            <div class="text-center">
              <span class="text-muted fs09"><i class="fa fa-search"></i> Pesquisa por <b>parte do nome</b> ou
                <b>matrícula</b> do funcionário</span>
            </div>
            <div class="input-group mt-3">
              <input type="text" class="form-control" list="listfuncionarios" id="datalistFuncionarios"
                (change)="changeDataListFuncionarios($event.target.value)" maxlength="90" />
              <div class="input-group-append cp" (click)="limparDataListFuncionarios()"
                title="limpar campo e recarregar lista completa de opções">
                <span class="input-group-text"><i class="fa fa-trash"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- row 1 col 2 -->
          <div class="offset-md-3 col-md-6">


            <div class="text-center mb-2">
              <span class="text-muted">Selecione um ou mais na lista e clique em adicionar</span>
            </div>
            <div class="box-table-sm fs09" style="height: 120px">
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Matrícula</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let f of this.possiveisColaboradoresListaGrid" (click)="selectColaborador(f.id)"
                    class="alert cp" [ngClass]="{ 'tr-info': f.marcado }">
                    <td>{{ f.nome }}</td>
                    <td class="text-center">{{ f.matricula }}</td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div class="row mt-2">
              <!-- row 2 -->
              <div class="col-md-8">
                <div class="d-flex justify-content-start mt-2">
                  <span *ngIf="
                    this.possiveisColaboradoresListaGrid.length <
                    osCompleta?.possiveisColaboradores.length
                  ">
                    Total funcionários (filtrados) :
                  </span>
                  <span *ngIf="
                    this.possiveisColaboradoresListaGrid.length ==
                    osCompleta?.possiveisColaboradores.length
                  ">
                    Total funcionários :
                  </span>
                  <span><b>{{ this.possiveisColaboradoresListaGrid.length }}</b></span>



                </div>


              </div>
              <div class="col-md-4 text-center">
                <button class="btn btn-block btn-info" (click)="adicionarColaboradores()"
                  title="Confirmar colaboradores selecionados">
                  Adicionar
                </button>
              </div>
            </div>





          </div>
        </div>

        <div class="row">
          <div class="col-md-12">

            <div class="box-table fs09" style="height: 240px">
              <table>
                <thead>
                  <tr>
                    <th colspan="5"><b>Lista de colaboradores informados</b>
                      <span *ngIf="this.osCompleta?.spvCompleto?.colaboradores?.length > 0"
                        class="badge badge-pill badge-warning pull-right pt-1">{{
                        osCompleta?.spvCompleto?.colaboradores?.length }}
                      </span>

                    </th>
                  </tr>
                  <tr>
                    <th class="wf250">Nome</th>
                    <th>Matrícula</th>
                    <th *ngIf="this.osCompleta?.osFechamentoId != null">Data/Hora inicial </th>
                    <th *ngIf="this.osCompleta?.osFechamentoId != null">Data/Hora final</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let f of osCompleta?.spvCompleto?.colaboradores; let i = index">
                    <td>{{ f.nome }}</td>
                    <td class="text-center">{{ f.matricula }}</td>

                    <td *ngIf="this.osCompleta?.osFechamentoId != null">
                      <div class="input-group">
                        <input type="datetime-local" id="data-hi-colaborador{{i}}" class="form-control" tabindex="1"
                          [value]="f.dataHoraInicio | date: 'yyyy-MM-dd HH:mm'" max="9999-12-31T23:59:59" />
                        <div class="input-group-append cp"
                          (click)="clearInputDataHiColaborador('data-hi-colaborador', i)" title="limpar">
                          <span class="input-group-text"><i class="fa fa-times"></i></span>
                        </div>

                      </div>

                    </td>

                    <td *ngIf="this.osCompleta?.osFechamentoId != null">
                      <div class="input-group">
                        <input type="datetime-local" id="data-hf-colaborador{{i}}" class="form-control" tabindex="1"
                          [value]="f.dataHoraFim | date: 'yyyy-MM-dd HH:mm'" max="9999-12-31T23:59:59" />
                        <div class="input-group-append cp"
                          (click)="clearInputDataHiColaborador('data-hf-colaborador', i)" title="limpar">
                          <span class="input-group-text"><i class="fa fa-times"></i></span>
                        </div>

                      </div>

                    </td>

                    <td class="text-center">
                      <button class="btn btn-sm" (click)="removerColaborador(i)" title="remover da lista">
                        <i class="fa fa-trash text-secoundary"></i>
                      </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>

      </div>
    </div>


  </div>


  <div class="modal-footer mt-2">

    <div class="col-md-6 d-flex justify-content-start">
    </div>
    <div class="col-md-3">
      <!--  <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">
          Cancelar
        </button> -->
    </div>
    <div class="col-md-3">
      <button type="button" class="btn btn-secondary btn-block" (click)="confirmarColaboradores(c)">
        {{
        osCompleta?.spvCompleto?.colaboradores?.length > 0
        ? "Confirmar"
        : "Fechar"
        }}
      </button>
    </div>

  </div>


</ng-template>

<ng-template #modalirregularidades let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Informar Irregularidades</h4>
  </div>

  <div class="modal-body pl-5 pr-5 pb-0">

    <div class="row">

      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue fb">Irregularidades disponíveis</span><br />
          <span class="text-muted">Selecione uma ou mais na lista e confirme</span>
        </div>
        <div class="divider"></div>
        <div class="box-table fs09" style="height: 327px;">
          <table>
            <thead>
              <tr>
                <th style="width: 180px;">Tipo Irregularidade</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of osCompleta?.possiveisIrregularidades" (click)="selectIrregularidade(i.id)"
                class="alert cp" [ngClass]="{'tr-info' : i.marcado}">
                <td class="text-center">{{ i.tipoIrregularidade }}</td>
                <td class="text-left">{{ i.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-2 text-center">
        <button class="btn cp" (click)="adicionarIrregularidades()" style="margin-top: 180px;"
          title="Confirmar Irregularidade selecionada">
          <img src="./assets/images/arrow-right.png" />
        </button><br />
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>

      <div class="col-md-5">

        <div class="text-center mt-3">
          <span class="txt-blue fb">Irregularidades inseridas na atual OS</span><br />

        </div>
        <div class="divider"></div>

        <div class="box-table h350 fs09">
          <table>
            <thead>
              <tr>
                <th style="width: 150px;">Tipo Irregularidade</th>
                <th>Descrição</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of osCompleta?.irregularidades">
                <td class="text-center">{{ i.tipoIrregularidade }} </td>
                <td class="text-left">{{ i.descricao }}</td>

                <td class="text-center"><button class="btn btn-sm" (click)="removerIrregularidade(i)"
                    title="remover da lista"><i class="fa fa-trash text-secoundary"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mt-2">Total irregularidades informadas :
            <b>{{ osCompleta?.irregularidades?.length }}</b> </span>
        </div>

      </div>

    </div>


  </div>
  <div class="modal-footer mt-2">
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">
            {{osCompleta?.irregularidades?.length > 0 ? "Confirmar" : "Fechar"}}
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-template>


<ng-template #modalMateriais let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Informar Materiais</h4>
  </div>

  <div class="modal-body h650 pl-5 pr-5">

    <div class="row">

      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue db">Materiais disponíveis</span>
        </div>
        <div class="divider"></div>
        <div class="text-center">
          <span class="text-muted fs09"><i class='fa fa-search'></i> Pesquisa por <b>parte do código</b>,
            <b>descrição</b> ou <b>tipo material</b></span>
        </div>
        <div class="input-group mt-3">
          <input type="text" class="form-control" list="listmateriais" id="datalistMateriais"
            (change)="changeDataListMateriais($event.target.value)" maxlength="200" />
          <div class="input-group-append cp" (click)="limparDataListMateriais()"
            title="limpar campo e recarregar lista completa de opções">
            <span class="input-group-text"><i class="fa fa-trash"></i></span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="text-center mb-2">
          <span class="text-muted">Selecione um ou mais na lista, informe as quantidades e confirme</span>
        </div>

        <div class="box-table-sm fs09" style="height: 350px;">
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Unidade</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.possiveisMateriaisListaGrid" class="alert cp"
                [ngClass]="{'tr-info' : item.marcado}">
                <td class="text-center" (click)="selectMateriais(item.materialId)">{{ item.codigo }}</td>
                <td class="text-center" (click)="selectMateriais(item.materialId)">{{ item.descricao }}</td>
                <td class="text-center">
                  <input [id]="item.materialId" type="number" class="form-control" min="1"
                    (change)="item.quantidade = $event.target.value" />
                  <span *ngIf="item.touched && item.quantidade == 0 && item.marcado" class="text-danger">Campo
                    obrigatório.</span>
                </td>
                <td class="text-center" (click)="selectMateriais(item.materialId)">{{ item.unidade }}</td>

              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start mt-2">
          <span *ngIf="this.possiveisMateriaisListaGrid.length < osCompleta?.possiveisMateriais.length">
            Total materiais (filtrados) :
          </span>
          <span *ngIf="this.possiveisMateriaisListaGrid.length == osCompleta?.possiveisMateriais.length">
            Total materiais :
          </span>
          <span><b>{{ this.possiveisMateriaisListaGrid.length | zerosEsquerda : 3 }}</b></span>
        </div>
      </div>

      <div class="col-md-2 text-center">
        <button class="btn cp" (click)="adicionarMateriais()" style="margin-top: 270px;"
          title="Confirmar material selecionado">
          <img src="./assets/images/arrow-right.png" />
        </button><br />
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>

      <div class="col-md-5">

        <div class="text-center mt-3">
          <span class="txt-blue db">Materiais inseridos na atual OS</span>
        </div>
        <div class="divider"></div>

        <div class="box-table fs09" style="height: 490px;">
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Unidade</th>
                <th class="wf20"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of osCompleta?.materiaisUsado">
                <td class="text-center">{{ item.codigo }}</td>
                <td class="text-center">{{ item.descricao }}</td>
                <td class="text-center">{{ item.quantidade }}</td>
                <td class="text-center">{{ item.unidade }}</td>

                <td class="text-center"><button class="btn btn-sm" (click)="removerMateriais(item)"
                    title="remover da lista"><i class="fa fa-trash text-secoundary"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mt-2">Total de materiais informados:
            <b>{{ osCompleta?.materiaisUsado?.length }}</b> </span>
        </div>


      </div>

    </div>


  </div>
  <div class="modal-footer mt-2">
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
        </div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding:10px; background: #141518 ;">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #modalLog let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Histórico de alterações - OS Nº {{this.osCompleta.osId | zerosEsquerda : 5}}</h4>
  </div>

  <div class="modal-body pl-5 pr-5 pb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="box-table" style="height: 500px;">
          <table>
            <thead>
              <tr>
                <th>Data</th>
                <th>Alterado Por</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of this.osCompleta.logsAlteracoesOSs">
                <td class="text-center">{{ log.dataHora | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-center">{{ log.usuario.nome }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-2">
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-template>


<ng-template #modalReaberturaOS let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Reabrir OS</h4>
  </div>

  <div class="modal-body pt-0 mt-0 tarja-edit">

    <div class="row mt-3 h400">
      <div class="col-md-1 box-left">
        <span class="material-icons icon-theme">
          settings_backup_restore
        </span>
      </div>

      <div class="col-md-11">

        <div class="row">
          <div class="col-md-12">
            <div class="bx-tb-default-t1" style="min-height: 180px; ">
              <table class="table table-bordered">
                <tbody class="tbody-default table-dados-os">
                  <tr>
                    <th>OS</th>
                    <td>{{osCompleta?.osId | zerosEsquerda: 5}}</td>
                  </tr>
                  <tr>
                    <th>Data/Hora do Cadastro</th>
                    <td>{{osCompleta?.spvCompleto.dataHoraCadastro | date:'dd/MM/yyyy HH:mm'}}</td>
                  </tr>
                  <tr>
                    <th>Requisitante</th>
                    <td>{{osCompleta?.spvCompleto.requisitante}}</td>
                  </tr>
                  <tr>
                    <th>Serviço</th>
                    <td>{{osCompleta?.spvCompleto.servico}}</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row d-flex justify-content-center align-items-center mb-3 mt-3">
              <span class="modal-title">Justificativa da Reabertura</span>
            </div>
            <div class="position-relative row form-group mt-2" style="min-height: 85px;">
              <div class="col-md-12">
                <textarea rows="5" class="form-control" type="text" #justificativaAbertura maxlength="500"
                  style="resize:none"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-md-6"></div>
    <div class="col-md-3">
      <button type="button" class="btn btn-light btn-block" (click)="c('Close click')">Retornar</button>
    </div>
    <div class="col-md-3">
      <button type="button" class="btn btn-primary btn-block"
        (click)="confirmarReaberturaOS(osCompleta?.osId, justificativaAbertura.value, c)">Confirmar a
        Reabertura</button>
    </div>
  </div>
</ng-template>